﻿/* MUNLER — main.js */

(function () {
    'use strict';

    // ── Images: one patient retry ───────────────────────────
    // Shopify's file servers occasionally answer a single request with a 502,
    // most often right after a theme goes live. A broken-image box for that is
    // avoidable: try the same file again after a moment (twice at most). A tile
    // in the photo strip that still fails is hidden rather than left broken.
    document.addEventListener('error', function (e) {
        var img = e.target;
        if (!img || img.tagName !== 'IMG' || !img.src) return;
        var tries = parseInt(img.getAttribute('data-retry') || '0', 10);
        if (tries >= 2) {
            var tile = img.closest('.photo-marquee-item');
            if (tile) tile.style.display = 'none';
            return;
        }
        img.setAttribute('data-retry', String(tries + 1));
        var base = img.src.replace(/([?&])r=\d+&?/, '$1').replace(/[?&]$/, '');
        setTimeout(function () {
            img.src = base + (base.indexOf('?') > -1 ? '&' : '?') + 'r=' + (tries + 1);
        }, 1200 * (tries + 1));
    }, true);

    // ── Black Friday countdown (real date, same for everyone) ──
    // Counts to a fixed moment (data-bf-start / data-bf-countdown, UTC), measured
    // against the shop's server clock (Date header), not the visitor's device clock,
    // so a wrong phone or PC clock cannot show a wrong time. Once the moment has
    // passed, the countdown and the announcement message disappear.
    (function () {
        var bfMsg = document.querySelector('[data-bf-message]');
        var bfBox = document.querySelector('[data-bf-countdown]');
        var target = Date.parse((bfMsg && bfMsg.getAttribute('data-bf-start')) || (bfBox && bfBox.getAttribute('data-bf-countdown')) || '');
        if (isNaN(target)) { return; }
        var skew = 0; // server time minus device time, in ms
        function now() { return Date.now() + skew; }
        function pad(n) { return (n < 10 ? '0' : '') + n; }
        function tick() {
            var left = target - now();
            if (left <= 0) {
                if (bfBox) { bfBox.hidden = true; }
                if (bfMsg && bfMsg.parentNode) { bfMsg.parentNode.removeChild(bfMsg); bfMsg = null; }
                return;
            }
            var mins  = Math.floor(left / 60000);
            var days  = Math.floor(mins / 1440);
            var hours = Math.floor((mins % 1440) / 60);
            var m     = mins % 60;
            if (bfBox) {
                bfBox.hidden = false;
                bfBox.querySelector('[data-cd="d"]').textContent = pad(days);
                bfBox.querySelector('[data-cd="h"]').textContent = pad(hours);
                bfBox.querySelector('[data-cd="m"]').textContent = pad(m);
            }
            var txt = bfMsg && bfMsg.querySelector('[data-bf-text]');
            if (txt) {
                txt.textContent = days >= 2 ? 'Black Friday in ' + days + ' days, join the list'
                               : days === 1 ? 'Black Friday in 1 day, join the list'
                               : 'Black Friday opens today, join the list';
            }
        }
        tick();
        setInterval(tick, 20000);
        if (window.fetch) {
            fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
                var d = Date.parse(r.headers.get('Date') || '');
                if (!isNaN(d)) { skew = d - Date.now(); tick(); }
            }).catch(function () {});
        }
    })();

    // ── Announcement bar: slow fade between the messages ─────
    var annMsgs = document.querySelectorAll('.announcement-msg');
    var annReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (annMsgs.length > 1 && !annReduced) {
        var annIdx = 0;
        setInterval(function () {
            annMsgs[annIdx].classList.remove('is-active');
            annIdx = (annIdx + 1) % annMsgs.length;
            annMsgs[annIdx].classList.add('is-active');
        }, 5500);
    }

    // ── Smart header + announcement bar ─────────────────────
    var header          = document.getElementById('site-header');
    var announcementBar = document.querySelector('.announcement-bar');
    var hasHero         = !!document.querySelector('.hero');
    var lastScrollY     = 0;
    var AT_TOP_THRESHOLD = 8; // px — consider "at top" below this

    function onScroll() {
        var sy          = window.scrollY;
        var atTop       = sy < AT_TOP_THRESHOLD;
        var goingDown   = sy > lastScrollY;

        // ── Announcement bar: only visible at very top
        if (atTop) {
            announcementBar.classList.remove('ann-hidden');
        } else {
            announcementBar.classList.add('ann-hidden');
        }

        // ── Header
        if (atTop) {
            header.classList.remove('header-hidden');
            header.classList.remove('at-page-top');
            if (hasHero) {
                header.classList.remove('scrolled'); // transparent over hero
            } else {
                header.classList.add('scrolled');    // solid on non-hero pages
                header.classList.add('at-page-top'); // but stay below announcement bar
            }
        } else if (goingDown) {
            // Scrolling down: hide header
            header.classList.add('header-hidden');
            header.classList.remove('scrolled');
            header.classList.remove('at-page-top');
        } else {
            // Scrolling up: show solid header at top of viewport
            header.classList.remove('header-hidden');
            header.classList.add('scrolled');
            header.classList.remove('at-page-top');
        }

        lastScrollY = sy <= 0 ? 0 : sy;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load

    // ── Hero zoom-in on load ─────────────────────────────────
    const hero = document.querySelector('.hero');
    if (hero) {
        setTimeout(function () {
            hero.classList.add('loaded');
        }, 100);
    }

    // ── Mobile menu toggle ───────────────────────────────────
    const menuBtn  = document.getElementById('mobile-menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');

    if (menuBtn && mobileMenu) {
        menuBtn.setAttribute('aria-expanded', 'false');

        menuBtn.addEventListener('click', function () {
            var isOpen = mobileMenu.classList.toggle('open');
            menuBtn.classList.toggle('active');
            menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            if (isOpen) {
                var firstLink = mobileMenu.querySelector('a');
                if (firstLink) setTimeout(function(){ firstLink.focus(); }, 50);
            }
        });

        // Close when a link is clicked
        mobileMenu.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                mobileMenu.classList.remove('open');
                menuBtn.classList.remove('active');
                menuBtn.setAttribute('aria-expanded', 'false');
            });
        });

        // ESC key closes menu
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
                mobileMenu.classList.remove('open');
                menuBtn.classList.remove('active');
                menuBtn.setAttribute('aria-expanded', 'false');
                menuBtn.focus();
            }
        });

        // Focus trap within mobile menu
        mobileMenu.addEventListener('keydown', function(e) {
            if (!mobileMenu.classList.contains('open') || e.key !== 'Tab') return;
            var focusable = Array.from(mobileMenu.querySelectorAll('a'));
            if (focusable.length === 0) return;
            var first = focusable[0];
            var last  = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                menuBtn.focus();
            }
        });
    }

    // ── Cart counter ─────────────────────────────────────────
    var cartTotal = 0;
    var cartCountEl = document.getElementById('cart-count');

    document.querySelectorAll('.btn-add-cart').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.stopPropagation();

            cartTotal++;
            if (cartCountEl) cartCountEl.textContent = cartTotal;

            var original = btn.textContent;
            btn.textContent = 'Added ✓';
            btn.style.background = '#1C1C1C';
            btn.style.color = '#fff';

            setTimeout(function () {
                btn.textContent = original;
                btn.style.background = '';
                btn.style.color = '';
            }, 1600);
        });
    });

    // ── Scroll-reveal (IntersectionObserver) ─────────────────
    var revealObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    revealObserver.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.reveal').forEach(function (el) {
        revealObserver.observe(el);
    });


    // ── Videolari sadece goruntuye girince yukle ─────────────
    // autoplay ozniteligi preload="none" degerini gecersiz kilip videoyu
    // sayfa acilir acilmaz indiriyordu. Urun sayfasinda bu 4 MB'lik bir on
    // yukleme demekti ve mobilde ilk acilisi bekletiyordu.
    //
    // Video goruntuye girince autoplay'i geri veriyoruz. Boylece oynatmayi
    // biz zorlamiyoruz, tarayici kendi kurallariyla basliyor. Sekme arka
    // planda ise Chrome sessiz videoyu guc tasarrufu icin duraklatir ve
    // sekme one gelince kendisi devam ettirir.
    var lazyVideos = document.querySelectorAll('video[data-lazyplay]');
    if (lazyVideos.length) {
        var basla = function (v) {
            if (v.dataset.basladi) { return; }
            v.dataset.basladi = '1';
            v.preload = 'auto';
            v.autoplay = true;
            v.load();
            var istek = v.play();
            if (istek && istek.catch) { istek.catch(function () {}); }
        };

        if ('IntersectionObserver' in window) {
            var videoObserver = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            basla(entry.target);
                            videoObserver.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.2, rootMargin: '300px 0px' }
            );
            lazyVideos.forEach(function (v) { videoObserver.observe(v); });
        } else {
            // Cok eski tarayici: gozlemci yoksa hepsini normal sekilde baslat
            lazyVideos.forEach(basla);
        }

        // Sekme arka planda acilmissa oynatma reddedilir. One gelince tekrar dene.
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState !== 'visible') { return; }
            lazyVideos.forEach(function (v) {
                if (v.dataset.basladi && v.paused) {
                    var istek = v.play();
                    if (istek && istek.catch) { istek.catch(function () {}); }
                }
            });
        });
    }

    // ── Smooth scroll for anchor links ───────────────────────
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                var headerOffset = 80;
                var top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    });

    // ── Hero slider ──────────────────────────────────────────
    var heroSlideEls = document.querySelectorAll('.hero-slide');
    var heroDotEls   = document.querySelectorAll('.hero-dot');
    if (heroSlideEls.length > 1) {
        var activeSlide = 0;
        var sliderTimer;

        function goToSlide(n) {
            heroSlideEls[activeSlide].classList.remove('is-active');
            heroDotEls[activeSlide].classList.remove('is-active');
            activeSlide = (n + heroSlideEls.length) % heroSlideEls.length;
            heroSlideEls[activeSlide].classList.add('is-active');
            heroDotEls[activeSlide].classList.add('is-active');
            // Pause/play video on its slide. Video baslarken basa sarilir, boylece
            // her giriste ilk saniyeden izlenir.
            heroSlideEls.forEach(function(slide, i) {
                var vid = slide.querySelector('video');
                if (!vid) { return; }
                if (i === activeSlide) {
                    try { vid.currentTime = 0; } catch (e) {}
                    var istek = vid.play();
                    if (istek && istek.catch) { istek.catch(function () {}); }
                } else {
                    vid.pause();
                }
            });
            resetSliderTimer();
        }

        function resetSliderTimer() {
            clearInterval(sliderTimer);
            sliderTimer = setInterval(function () { goToSlide(activeSlide + 1); }, 8000);
        }

        var prevBtn = document.querySelector('.hero-arrow--prev');
        var nextBtn = document.querySelector('.hero-arrow--next');
        if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(activeSlide - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(activeSlide + 1); });
        heroDotEls.forEach(function (dot, i) {
            dot.addEventListener('click', function () { goToSlide(i); });
        });

        // Parmakla kaydirma: sola = sonraki, saga = onceki. Dikey kaydirma (sayfa
        // gezme) ve dokunuslar etkilenmez.
        var heroEl = document.querySelector('.hero');
        if (heroEl) {
            var swX = 0, swY = 0, swOn = false;
            heroEl.addEventListener('touchstart', function (e) {
                if (e.touches.length !== 1) { swOn = false; return; }
                swX = e.touches[0].clientX;
                swY = e.touches[0].clientY;
                swOn = true;
            }, { passive: true });
            heroEl.addEventListener('touchend', function (e) {
                if (!swOn) { return; }
                swOn = false;
                var t = e.changedTouches[0];
                var dx = t.clientX - swX;
                var dy = t.clientY - swY;
                if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                    goToSlide(activeSlide + (dx < 0 ? 1 : -1));
                }
            }, { passive: true });
        }

        resetSliderTimer();

        // Ilk slayt fotograf. Hero videosunu fotograf yuklenip sayfa oturduktan
        // sonra arka planda hazirliyoruz; boylece ilk gorsel hizli acilir ve
        // gecis geldiginde video hazir olur.
        var heroVideo = document.querySelector('video[data-hero-video]');
        if (heroVideo) {
            var heroVideoHazirla = function () {
                heroVideo.preload = 'auto';
                heroVideo.load();
            };
            if (document.readyState === 'complete') {
                setTimeout(heroVideoHazirla, 500);
            } else {
                window.addEventListener('load', function () { setTimeout(heroVideoHazirla, 500); });
            }
        }
    }

    // ── Search overlay ───────────────────────────────────────
    var SEARCH_PRODUCTS = [
        {
            name: 'The Brook Mirror', variant: 'Champagne Gold', price: '£209',
            img: 'https://munler.co.uk/cdn/shop/files/Gemini_Generated_Image_911uwy911uwy911u_e7d39ccc-05d1-48df-b1ad-be72125a156c.png',
            url: '/products/the-brook-mirror'
        },
        {
            name: 'The Brook Mirror', variant: 'Matte Black', price: '£189',
            img: 'https://munler.co.uk/cdn/shop/files/Gemini_Generated_Image_q04fizq04fizq04f_93c8f86e-3b76-48f2-8f88-91396526d02c.png',
            url: '/products/the-brook-mirror-matte-black'
        },
        {
            name: 'The Solenne Mirror', variant: '', price: '£599',
            img: 'https://munler.co.uk/cdn/shop/files/Gemini_Generated_Image_xskxeuxskxeuxskx.png',
            url: '/products/the-solenne-mirror'
        },
        {
            name: 'The Rib End Table', variant: '', price: '£199',
            img: 'https://munler.co.uk/cdn/shop/files/Gemini_Generated_Image_en00uven00uven00_073900b8-d131-4da8-abf2-5d60f3b89639.png',
            url: '/products/the-rib-end-table'
        },
        {
            name: 'The Volta End Table', variant: '', price: '£299',
            img: 'https://munler.co.uk/cdn/shop/files/Gemini_Generated_Image_f348e2f348e2f348.png',
            url: '/products/the-volta-end-table'
        }
    ];

    // Inject overlay HTML
    var overlayEl = document.createElement('div');
    overlayEl.className = 'search-overlay';
    overlayEl.id = 'search-overlay';
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.innerHTML = [
        '<div class="search-panel" id="search-panel">',
        '  <div class="search-header">',
        '    <div class="search-input-row">',
        '      <svg class="search-icon-inline" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>',
        '      <input type="text" class="search-input" id="search-input" placeholder="Search products…" autocomplete="off" spellcheck="false">',
        '      <button class="search-close-btn" id="search-close-btn" aria-label="Close search">',
        '        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '      </button>',
        '    </div>',
        '  </div>',
        '  <div class="search-body">',
        '    <p class="search-results-label" id="search-results-label">All Products</p>',
        '    <div class="search-grid" id="search-grid"></div>',
        '    <div class="search-empty" id="search-empty"><p>No products found for &ldquo;<strong id="search-query-display"></strong>&rdquo;</p></div>',
        '  </div>',
        '</div>'
    ].join('');
    document.body.appendChild(overlayEl);

    var searchOverlay    = document.getElementById('search-overlay');
    var searchInput      = document.getElementById('search-input');
    var searchGrid       = document.getElementById('search-grid');
    var searchEmpty      = document.getElementById('search-empty');
    var searchLabel      = document.getElementById('search-results-label');
    var searchCloseBtn   = document.getElementById('search-close-btn');
    var searchQueryDisp  = document.getElementById('search-query-display');

    var searchDebounce;

    // Clean a raw value from Shopify API that may have surrounding quotes or be a full URL
    function cleanShopifyString(raw) {
        var s = (raw || '').toString().replace(/^[“'\s]+|[“'\s]+$/g, '');
        return s;
    }

    // Extract a clean /products/handle path from whatever the API returns
    function getProductPath(p) {
        var raw = cleanShopifyString(p.url || p.handle || '');
        // If it's a full absolute URL (https://...), strip the origin
        if (/^https?:\/\//i.test(raw)) {
            raw = raw.replace(/^https?:\/\/[^\/]*/i, '');
        }
        if (!raw) return '/collections/all';
        if (!raw.startsWith('/')) raw = '/' + raw;
        return raw;
    }

    // Build a product card DOM element — DOM-based to avoid any HTML quote issues
    function buildCard(p, fromProductsJson) {
        var url = fromProductsJson
            ? '/products/' + (p.handle || '')
            : getProductPath(p);

        var imgSrc = '';
        if (fromProductsJson) {
            imgSrc = (p.images && p.images[0] && (p.images[0].src || p.images[0].url)) || '';
        } else {
            var fi = p.featured_image;
            imgSrc = fi ? cleanShopifyString(typeof fi === 'object' ? (fi.url || fi.src || '') : String(fi)) : '';
        }

        var rawPrice = fromProductsJson
            ? ((p.variants && p.variants[0] && p.variants[0].price) || '')
            : (p.price || '');
        var price = rawPrice ? '£' + parseFloat(rawPrice).toFixed(2).replace(/\.00$/, '') : '';
        var title = p.title || '';

        var a = document.createElement('a');
        a.className = 'search-product-card';
        a.href = url; // set as property — no HTML parsing, no quote issues

        var imgWrap = document.createElement('div');
        imgWrap.className = 'search-product-img-wrap';
        if (imgSrc) {
            var img = document.createElement('img');
            img.src = imgSrc;
            img.alt = title;
            img.className = 'search-product-img';
            img.loading = 'lazy';
            imgWrap.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'search-product-info';
        var pName = document.createElement('p');
        pName.className = 'search-product-name';
        pName.textContent = title;
        var pPrice = document.createElement('p');
        pPrice.className = 'search-product-price';
        pPrice.textContent = price;
        info.appendChild(pName);
        info.appendChild(pPrice);

        a.appendChild(imgWrap);
        a.appendChild(info);
        return a;
    }

    function showCards(cards, label) {
        searchGrid.innerHTML = '';
        if (!cards.length) {
            searchGrid.style.display = 'none';
            searchEmpty.style.display = 'block';
            searchLabel.textContent = label;
            return;
        }
        cards.forEach(function(card) { searchGrid.appendChild(card); });
        searchGrid.style.display = 'grid';
        searchEmpty.style.display = 'none';
        searchLabel.textContent = label;
    }

    // Load all products when search opens (no query)
    function loadAllProducts() {
        searchLabel.textContent = 'All Products';
        fetch('/collections/all/products.json?limit=8&sort_by=created-desc')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                var products = data.products || [];
                showCards(products.map(function(p) { return buildCard(p, true); }), 'All Products');
            })
            .catch(function() { searchLabel.textContent = 'All Products'; });
    }

    function renderProducts(query) {
        var q = query.trim();
        clearTimeout(searchDebounce);

        if (!q) {
            loadAllProducts();
            return;
        }

        searchDebounce = setTimeout(function() {
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6' +
                  '&resources[options][unavailable_products]=last')
                .then(function(r) { return r.json(); })
                .then(function(data) {
                    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
                    if (!products.length) { searchQueryDisp.textContent = query; }
                    showCards(
                        products.map(function(p) { return buildCard(p, false); }),
                        products.length ? 'Results for “' + query + '”' : 'No results'
                    );
                })
                .catch(function() {
                    searchGrid.style.display = 'none';
                    searchEmpty.style.display = 'block';
                    searchQueryDisp.textContent = query;
                    searchLabel.textContent = 'Search unavailable';
                });
        }, 220);
    }

    function openSearch() {
        searchOverlay.classList.add('is-open');
        searchOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        loadAllProducts();
        setTimeout(function () { searchInput.focus(); }, 80);
    }

    function closeSearch() {
        searchOverlay.classList.remove('is-open');
        searchOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        searchInput.value = '';
    }

    // Wire search icon buttons (there may be multiple on a page)
    document.querySelectorAll('[aria-label="Search"]').forEach(function (btn) {
        btn.addEventListener('click', openSearch);
    });

    searchCloseBtn.addEventListener('click', closeSearch);

    // Click on the backdrop (overlay itself, not the panel) → close
    searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearch();
    });

    searchInput.addEventListener('input', function () {
        renderProducts(this.value);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
            closeSearch();
        }
    });

})();
